import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, authReady } = useAuth();
  if (!authReady) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface">
        <div className="label-tag animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}
